import React from "react"
import { FaCode, FaSatellite, FaCamera } from "react-icons/fa"
export default [
  {
    id: 1,
    icon: <FaCode className="service-icon" />,
    title: "web development",
    text: `i'am a junior front end web developer, graduated from Flatiron school.I'am experienced in Javascript,Reactjs and familiar with back-end technologies like nodejs,mysql and typescript.`,
  },
  {
    id: 2,
    icon: <FaSatellite className="service-icon" />,
    title: "Satellite producer",
    text: `I'm  an experienced producer, i worked with many channels and agencies like Aljazeera,Alarabi and Ihlas news agency `,
  },
  {
    id: 3,
    icon: <FaCamera className="service-icon" />,
    title: "photographer",
    text: `Photography is a hobby for me,i like taking photos of events, places or friends.you can check the photos i took on my instagram page  `,
  },
]
